import { phaseTypes } from "../../config/phaseTypes.enum"
import { AddEntity } from "./AddEntity"
import { OwnerDetails } from "./OwnerDetails"
import { OwnerDocuments } from "./OwnerDocuments"

const generateStructure = ({
    phase,
    includeStructure,
    errorHandler,
    relationChangeHandler,
    onSelectSubsidiary,
    setTypeOfNewEntity,
    typeOfNewEntity,
    setLookupType,
    setTypeOfEntity,
    isEdit,
    isLookup,
    isOwnershipAllowed,
    isLoading = false,
    cpCategories,
    supportedRegions,
    country,
    cleanValues,
    inputChangedHandler,
    isRequest
}) => {
    if (phase === phaseTypes.PREAPPROVAL && !includeStructure) return {}

    const SELECT_ENTITY_FORM = {
        id: "addType",
        component: AddEntity,
        props: {
            relationChangeHandler,
            onSelectSubsidiary,
            setTypeOfNewEntity,
            typeOfNewEntity,
            setLookupType,
            setTypeOfEntity,
            isEdit,
            isLookup,
            isOwnershipAllowed,
        },
    }

    const OWNER_DOCUMENTS = {
        id: "addType",
        component: OwnerDocuments,
        props: {
            errorHandler,
            typeOfNewEntity,
        },
    }

    const OWNER_COMPANY_FORM = {
        id: "structureCompanyForm",
        title: "structureCompanyForm",
        form: OwnerDetails,
        props: {
            type: "COMPANY",
            cpCategories: cpCategories['CONNECTED_COMPANY'],
            inputChangedHandler,
            errorHandler,
            isEdit,
            supportedRegions,
            country,
            cleanValues,
            isLoading,
            isRequest
        }
    }

    const OWNER_PERSON_FORM = {
        id: "structurePersonForm",
        title: "structurePersonForm",
        form: OwnerDetails,
        props: {
            type: "PERSON",
            cpCategories: cpCategories['CONNECTED_PERSON'],
            inputChangedHandler,
            errorHandler,
            isEdit,
            supportedRegions,
            country,
            cleanValues,
            isLoading,
            isRequest
        }
    }

    return {
        selectEntity: SELECT_ENTITY_FORM,
        COMPANY: OWNER_COMPANY_FORM,
        PERSON: OWNER_PERSON_FORM,
        ownerDocs: OWNER_DOCUMENTS,
    }
}

export { generateStructure }
